import { useCallback, useRef } from "react";
import { applyRef } from "./applyRef";
/**
 * This is mostly an enternal hook that allows for an optional ref (normally
 * from props or hook options) to be merged with a hook's required `ref`. This
 * will return a MutableRefObject used for DOM manipulation in a custom hook
 * followed by a ref callback function that should be passed to the DOM node
 * that will ensure that both the optional `propRef` and hook ref are updated.
 *
 * @remarks \@since 2.3.0
 */
export function useEnsuredRef(propRef) {
    var ref = useRef(null);
    var refHandler = useCallback(function (instance) {
        applyRef(instance, propRef);
        ref.current = instance;
    }, [propRef]);
    return [ref, refHandler];
}
//# sourceMappingURL=useEnsuredRef.js.map